var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-0"},[_c('v-combobox',{attrs:{"disabled":_vm.readonly,"items":_vm.datos,"loading":_vm.isLoading,"hide-details":"","outlined":"","dense":"","label":_vm.xholder},model:{value:(_vm.modelo.idusuario),callback:function ($$v) {_vm.$set(_vm.modelo, "idusuario", $$v)},expression:"modelo.idusuario"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }